module.exports = __webpack_public_path__ + "za.1f888ad462f3db9c1dea.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/za.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/za.svg
// module chunks = styles